import {decrypt} from "@/util/encrypt";

export default (to, from, next) => {
  try {
    if (!to.meta.requiresAuth) {
      next();
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
      const store = localStorage.getItem('oanda-type-admin-am')
      if(store){
        const role = decrypt(store)
        if (role) {
          const arrayRole = to.matched.filter(x => x.meta.roles).map(x => x.meta.roles);
          if (arrayRole.every(x => x.some(r => role.includes(r)))) {
            next();
          } else {
            next('/login');
          }
        } else {
          next('/login');
        }
      }else{
        next('/login');
      }
    } else {
      next();
    }
  } catch (e) {
    console.error(e);
  }
}
